import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
import _styled from "styled-components";

function _createForOfIteratorHelperLoose(o, allowArrayLike) {
  var it;

  if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) {
    if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
      if (it) o = it;
      var i = 0;
      return function () {
        if (i >= o.length) return {
          done: true
        };
        return {
          done: false,
          value: o[i++]
        };
      };
    }

    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  it = o[Symbol.iterator]();
  return it.next.bind(it);
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

import PropTypes from "prop-types";
import React, { useEffect, useRef } from "react";
import ReactToggle from "react-toggle";
import styled from "styled-components";
import Label from "./label";
import "react-toggle/style.css";
import "../stylesheets/toggle.css";
export var ToggleGroup = function ToggleGroup(_ref) {
  var label = _ref.label,
      name = _ref.name,
      onChange = _ref.onChange,
      checked = _ref.checked,
      className = _ref.className,
      style = _ref.style,
      rest = _objectWithoutPropertiesLoose(_ref, ["label", "name", "onChange", "checked", "className", "style"]);

  var id = name.replace(/[\W]/g, "");
  return (
    /*#__PURE__*/
    React.createElement(Aligner, {
      className: className,
      style: style
    },
    /*#__PURE__*/
    React.createElement(Toggle, _extends({
      id: id,
      name: name,
      checked: checked,
      onChange: onChange
    }, rest)),
    /*#__PURE__*/
    React.createElement(Label, {
      htmlFor: id
    }, label))
  );
};
ToggleGroup.propTypes = {
  label: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  checked: PropTypes.bool,
  className: PropTypes.string,
  style: PropTypes.object
};

var _StyledDiv =
/*#__PURE__*/
styled("div").withConfig({
  displayName: "_StyledDiv"
})(["display:inline-block;line-height:0;"]);

export var Toggle = function Toggle(props) {
  var divRef = useRef(); // gotta use a wrapper because react-toggle won't forward refs
  // What this essentially does is mirror data-focus-visible-added on the internal <input> onto the react-toggle thumb

  useEffect(function () {
    var reactToggleThumb = divRef.current.querySelector(".react-toggle-thumb");
    var reactToggleInput = divRef.current.querySelector(".react-toggle input");
    var observer = new MutationObserver(function (mutationList) {
      for (var _iterator = _createForOfIteratorHelperLoose(mutationList), _step; !(_step = _iterator()).done;) {
        var mutation = _step.value;

        if (mutation.type === "attributes" && mutation.attributeName === "data-focus-visible-added") {
          if (mutation.target.hasAttribute("data-focus-visible-added")) {
            reactToggleThumb.setAttribute("data-focus-visible-added", "");
          } else {
            reactToggleThumb.removeAttribute("data-focus-visible-added");
          }
        }
      }
    });
    observer.observe(reactToggleInput, {
      attributes: true
    });
    return function () {
      return observer.disconnect();
    };
  }, []);
  return (
    /*#__PURE__*/
    React.createElement(_StyledDiv, {
      ref: divRef
    },
    /*#__PURE__*/
    React.createElement(ReactToggle, _extends({
      icons: false
    }, props)))
  );
};
var Aligner =
/*#__PURE__*/
styled.div.withConfig({
  displayName: "Aligner"
})(["display:flex;align-items:center;& .react-toggle{flex-shrink:0;margin-right:8px;}"]);